export default "__VITE_ASSET__BjsJE0t___"